import { createTheme } from '@material-ui/core';
import createPalette from '@material-ui/core/styles/createPalette';
import createTypography from '@material-ui/core/styles/createTypography';
import colors from 'utils/stylesheet/colors';

const pickerTheme = createTheme({
  palette: {
    primary: {
      main: '#888eff',
      light: colors.white,
      dark: colors.dark_blue
    },
    secondary: {
      main: '#888eff'
    }
  },
  typography: createTypography(
    createPalette({
      primary: {
        main: '#888eff',
        light: colors.white,
        dark: colors.dark_blue
      },
      secondary: {
        main: '#888eff'
      }
    }),
    {
      fontFamily: 'Montserrat',
      fontSize: 13,
      fontWeightRegular: 600
    }
  )
});

export default pickerTheme;
